
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^((56|64)41|[27]89|1773|4268|4475|8867|895|9762)$/.test(chunkId);
},
rootOutputDir: "",

    };
}
